"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateApprovalMatrixSchema = exports.createApprovalMatrixSchema = exports.approvalStepSchema = void 0;
const zod_1 = require("zod");
exports.approvalStepSchema = zod_1.z.object({
    sequence: zod_1.z.number().int().positive(),
    roleId: zod_1.z.string().uuid(),
    isMandatory: zod_1.z.boolean().default(true),
});
exports.createApprovalMatrixSchema = zod_1.z.object({
    moduleName: zod_1.z.string().min(1).max(100),
    actionName: zod_1.z.string().min(1).max(100),
    steps: zod_1.z.array(exports.approvalStepSchema).min(1),
});
exports.updateApprovalMatrixSchema = zod_1.z.object({
    steps: zod_1.z.array(exports.approvalStepSchema).min(1).optional(),
});
//# sourceMappingURL=approval-matrix.schema.js.map